module.exports = __webpack_public_path__ + "img/hair-tools.f6850e0b.jpg";